import { render, staticRenderFns } from "./institutionalTeam.vue?vue&type=template&id=278edb00&scoped=true"
import script from "./institutionalTeam.vue?vue&type=script&lang=js"
export * from "./institutionalTeam.vue?vue&type=script&lang=js"
import style0 from "./institutionalTeam.vue?vue&type=style&index=0&id=278edb00&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278edb00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('278edb00')) {
      api.createRecord('278edb00', component.options)
    } else {
      api.reload('278edb00', component.options)
    }
    module.hot.accept("./institutionalTeam.vue?vue&type=template&id=278edb00&scoped=true", function () {
      api.rerender('278edb00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/institutionalTeam.vue"
export default component.exports